export enum EmriRasa {
  Emerore = 10,
  Gjinore = 11,
  Dhanore = 12,
  Kallezore = 13,
  Rrjedhore = 14,
  Vendore = 15,
  Thirrore = 16,
}

export enum EmriLloji {
  Ipergjithshem = 10,
  Ipervecem = 11,
  Permbledhes = 12,
  Lende = 13,
}

export enum EmriNumri {
  Njejes = 10,
  Shumes = 11,
  Vetemnenjejes = 12,
  Vetemneshumes = 13,
  Kryesishtnenjejes = 14,
  Kryesishtneshumes = 15,
}

export enum EmriTipi {
  Ipervecem = 10,
  Inyjshem = 11,
}

export enum EmriLakimi {
  Ipare = 10,
  Idyte = 11,
  Itrete = 12,
  Ikatert = 13,
}

export enum EmriTrajta {
  Eshquar = 10,
  Epashquar = 11,
}

export enum EmriGjiniaVecoria {
  Mashkullore = 10,
  Femerore = 11,
  Asnjanese = 12,
}

export enum EmriShumesi {
  SiNjejesi = 10,
  MePrapashtesa = 11,
  MeNderrimeTingujsh = 12,
  MeNderrimeTingujshDhePrapashtese = 13,
  NderrimeTeTjeraTingujsh = 14,
  MeNjeNdryshimTeMadh = 15,
  MeFormeSupletive = 16,
}
export enum EmriFormaFjales {
  cc = 10,
}
export enum EmriPrapashtesa {
  sinjeejeesi = 10,
  e = 11,
  eee = 12,
  aee = 13,
  a = 14,
  ee = 15,
  nj = 16,
  injmereenieteeee = 17,
  inj = 18,
  jzgjerimiN = 19,
  jzgjerimiR = 20,
  enj = 21,
  eer = 22,
  ra = 23,
  na = 24,
  qiellzorizimllj = 25,
  qiellzorizimrj = 26,
  qiellzorizimlljdhendeerrimzanorjaeparee = 27,
  qiellzorizimlljdhendeerrimzanorjaedytee = 28,
  ndeerrimzanoreuaoNJ = 29,
  qiellzorizimlljndeerrimzanoreshE = 30,
  ae = 31,
  ea = 32,
  ie = 33,
  ndeerrimzanoresheeuee = 34,
  qiellzorizimggjE = 35,
  mepeerbeerjepjeseerishtteenjeejteeoseteendryshmeMANUALISHT = 36,
  veteemmeqiellzorizimkq = 37,
  veteemmeqiellzorizimggj = 38,
  veteemmeqiellzorizimkqE = 39,
  veteemmeqiellzorizimggjE = 40,
  meqiellzorizimggjndeerrimzanorejeeiE = 41,
  meqiellzorizimkqndeerrimzanorejeaeE = 42,
  sinjeejeesiA = 43,
  sinjeejeesiJA = 44,
  sinjeejeesiJE = 45,
  sinjeejeesiTHEKSi = 46,
  aNYJeeee = 47,
  aNYJee = 48,
  pjesoreteeemeerzuaraIT = 49,
  pjesoreteeemeerzuaraeeT = 50,
  mbiemraasnjaneesteeemeerzuar = 51,
  aeel = 52,
  aull = 53,
  sinjeejeesiIE = 54,
  sinjeejeesiE = 55,
  sinjeejeesiTHEKSae = 56,
  sinjeejeesiTHEKS0 = 57,
  sinjeejeesiee = 58
}
